// extracted by mini-css-extract-plugin
module.exports = {"calendarControl":"calendarControls_calendarControl__XDgJx"};